<template>
  <div>

    <div class="center big-padding">
      Souhaitez-vous supprimer le maitrise <strong>{{user.nom}} {{user.prenom}} </strong> - <strong>{{user.arrondissement_id | allArrondissementName}}</strong> ? <br>Ce compte sera supprimé définitivement de l'application.
    </div>

    <div class="buttons">
      <div class="btn btn-primary" v-on:click='confirm()'>
        Supprimer
      </div>

      <div class="btn btn-default" v-on:click="$emit('close')">
        Annuler
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'user',
  ],
  methods: {
    confirm: function () {
      this.$store.dispatch('deleteUser', this.user)
      this.$emit('close')
    },
  },
}
</script>



// WEBPACK FOOTER //
// UserDeleteDef.vue?5632975b